import { Component } from 'react';
import moment from 'moment';
import { createCompany } from '../../../../../../../../insfrastructure/services/companies';
import ResponseModal from '../../../../../../../components/response-modal';
import { withRouter } from '../../../../../../../../insfrastructure/utils/with-router-component';
import { StaticValues } from '../../../../../../../../insfrastructure/services/static_values'
import companyImg from '../../../../../../../../assets/images/company.png';
import { TermsOfUseModal } from '../../../../../../../components/terms-of-use-modal';
import './styles.sass'

class Resume extends Component<{ company_data: Record<string, any>, about_company: Record<string, any>, company_user_data: Record<string, any>, navigate: any }> {
  state: Record<string, any> = {
    responseData: null,
    loading: false,
    renderTermsOfUse: false,
    job_types: [],
    genderOptions: [],
  }

  componentDidMount() {
    this.getStaticValues();
  }

  getStaticValues = async () => {
    try {  
      setTimeout(() => {
        const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;
        const job_types = staticValues.job_type;
        const genderOptions = Object.keys(staticValues.gender).map((key: any) => ({ value: key, label: staticValues.gender[key] }));
        console.log('Static values loaded:', staticValues);
        this.setState({ job_types, genderOptions });
      }, 1000);
    } catch (error) {
      console.error('Error loading static values:', error);
    }
  }

  onSubmit = async () => {
    if (this.state.loading) return;

    try {
      this.setState({ loading: true });

      let data = {
        ...this.props.company_data,
        ...this.props.about_company,
        ...this.props.company_user_data
      };

      data.cpf = data.cpf.replace(/[-.]/g, '');
      data.cnpj = data.cnpj.replace(/[./-]/g, '');
      data.date_of_birth = moment(data.date_of_birth).format('YYYY-MM-DD');

      if (data.ie_free) {
        delete data.ie;
      };

      await createCompany(data as any);
    
      this.props.navigate('/sign-up/company/confirmation/request', { state: { email: this.props.company_user_data.manager_email } });
    } catch (error: any) {
      let errors: string[] = [];

      if (error.response.data['user.email']) {
        errors.push('Email já cadastrado');
      };

      if (error.response.data['manager.email']) {
        errors.push('Email já cadastrado');
      };

      if (error.response.data['manager.cpf']) {
        errors.push('CPF já cadastrado');
      };

      if (error.response.data['company.ie']) {
        errors.push('IE já cadastrado');
      };
      
      if (error.response.data['company.cnpj']) {
        errors.push('CNPJ já cadastrado');
      };

      let responseData = {
        type: 'error',
        title: 'Erro ao cadastrar',
        text: () => <>
          { errors.map(error => <p>{error}</p>) }
        </>
      };

      this.setState({ loading: false, responseData });
    };
  }

  render() {
    return (
      <div className='resume'>
        <div className='form-container'>
          <div className='columns'>
            <div className='column'>
              <div className='data-block'>
                <h4>Dados Empresa</h4>
                <div>
                  <p>Nome de Empresa: <b>{this.props.company_data.fantasy_name}</b></p>
                  <p>CNPJ: <b>{this.props.company_data.cnpj}</b></p>
                  <p>IE: <b>{this.props.company_data.ie_free ? 'Isento' : (this.props.company_data.ie || '-')}</b></p>
                  <p>Telefone: <b>{this.props.company_data.phone}</b></p>
                  <p>Endereço: <b>{this.props.company_data.street + ', ' + this.props.company_data.address_number}</b></p>
                  <p>Cidade: <b>{this.props.company_data.city}</b></p>
                  <p>Estado: <b>{this.props.company_data.uf}</b></p>
                  <p>Tipo da Vaga: <b>{this.state.job_types[this.props.company_data.job_type.toLowerCase()] || '-'}</b></p>
                </div>
              </div>
              <div className='text-block'>
                <h4>Sobre a Empresa</h4>
                <p>{this.props.about_company.description}</p>
              </div>
            </div>
            <div className='column'>
              <div className='data-block'>
                <h4>Dados do Responsável</h4>
                <div>
                  <p>Nome Completo: <b>{this.props.company_user_data.full_name}</b></p>
                  <p>CPF: <b>{this.props.company_user_data.cpf}</b></p>
                  {/* <p>Celular: <b>{this.props.company_user_data.phone}</b></p> */}
                  <p>E-mail: <b>{this.props.company_user_data.manager_email}</b></p>
                  <p>Data de nascimento: <b>{moment(this.props.company_user_data.date_of_birth).format('DD/MM/yyyy')}</b></p>
                  <p>Gênero: <b>{this.state.genderOptions[this.props.company_user_data.gender] || '-'}</b></p>
                  {/* <p>Estado: <b>{this.props.company_user_data.uf}</b></p> */}
                  {/* <p>Cidade: <b>{this.props.company_user_data.city}</b></p> */}
                </div>
              </div>
              <div className='text-block'>
                <h4>Por que trabalhar com a gente?</h4>
                <p>{this.props.about_company.motivation}</p>
              </div>
            </div>
            <div className='column'>
              <img src={companyImg} alt='company' />
            </div>
          </div>
          <div className='submit-block'>
            <div>
              <h4>Aviso Importante</h4>
              <p>Ao confirmar esta ação, você declara e concorda que assume total responsabilidade pela precisão e veracidade das informações fornecidas em nome da empresa.
                Além disso, você se compromete a responder legalmente por qualquer consequência que possa advir de informações incorretas ou imprecisas, sendo a principal responsável pela credibilidade dos dados apresentados.
                Certifique-se de revisar todas as informações com atenção antes de prosseguir. A sua confirmação implica na aceitação dos termos acima e na responsabilidade legal associada.</p>
              <a 
                href='https://staging.empregamecanico.com.br/terms-of-use' 
                target='_blank' 
                rel='noopener noreferrer'
                style={{ color: '#FFD700', textDecoration: 'underline', fontWeight: '600', cursor: 'pointer' }}
              >
                Termos de Uso
              </a>
            </div>
            <button className='primary' disabled={this.state.loading} onClick={this.onSubmit}>
              { !this.state.loading ? 'Confirmar' : 'Enviando...' }
            </button>
          </div>
        </div>
        <ResponseModal
        render={this.state.responseData}
        type={this.state.responseData?.type}
        title={this.state.responseData?.title}
        text={this.state.responseData?.text}
        onClose={() => this.setState({ responseData: null })} />
        <TermsOfUseModal
        render={this.state.renderTermsOfUse}
        onClose={() => this.setState({ renderTermsOfUse: false })} />
      </div>
    )
  }
}

export const ResumeWithRouter = withRouter(Resume);

